import React from 'react';
import * as GDKTab from '@gdk/tabs'
import { Driver } from './../../models/Driver';
import { Vehicle } from '../../models/Vehicle';
import { PolicyInfo } from '../../models/PolicyInfo';

export interface PolicySearchResult {
    policyInfo: PolicyInfo;
    drivers: Array<Driver>;
    vehicles: Array<Vehicle>;
}

export interface TelematicsDetailsTabProps {
    policy: PolicyInfo;
    onTabChange: (tab: number) => void;
    initialTab: number;
}


export default class TelematicsDetailTabs extends React.Component<TelematicsDetailsTabProps>{

    componentDidMount() {
        window.scrollTo(0, 0);

        const searchOption = document.getElementsByName('state')[0] as HTMLInputElement;
        let initialTabNum: number = 1;

        switch (searchOption.value) {
            case "DriverId/CustomerKey":
                initialTabNum = 2;
                break;
            case "VehicleId":
                initialTabNum = 3;
                break;
        }

        const commercialTabs = new GDKTab.GdkTabs({
            content: '#commercialTelematicsTabs',
            initialTabOpen: initialTabNum,
            tabClicked: function () {

            },
        });

        const { policy } = this.props
        const comp = document.getElementById('divPolicyStatus');
        if (comp) {
            if (policy.currentPolicyStatus?.includes('$') === true) {
                comp.innerText = comp.innerText.replace('$','');
                comp.style.color = 'green';
            }
            else {
                comp.style.color = 'red';
            }
        }

    }

    renderTabs = () => (
        <div
            className="tabs-container"
        >
            <a
                id="tab-PolicyInfo"
                className="tab"
                href="/#"
                role="tab"
                aria-controls="panelPolicyInfo"
                onClick={() => this.props.onTabChange(1)}
            >
                <span>Policy Information</span>
            </a>
            <a
                id="tab-Driver"
                className="tab"
                href="/#"
                role="tab"
                aria-controls="panelDriver"
                onClick={() => this.props.onTabChange(2)}
            >
                <span>Drivers</span>
            </a>
            <a
                id="tab-Vehicle"
                className="tab"
                href="/#"
                role="tab"
                aria-controls="panelVehicle"
                onClick={() => this.props.onTabChange(3)}
            >
                <span>Vehicles</span>
            </a>
            <a
                id="tab-TagReplacement"
                className="tab"
                href="/#"
                role="tab"
                aria-controls="panelTagReplacement"
                onClick={() => this.props.onTabChange(4)}
            >
                <span>Tag Replacement</span>
            </a>
            <div id="divPolicyNumber" className="text-align-center-highlight">{this.renderPolicyNumber()}</div>
            <div id="divPolicyStatus" className="text-align-right">{this.renderPolicyStatus()}</div>
        </div>
    );

    renderPanels = () => {
        return React.Children.map(this.props.children, child => {
            return (
                <div
                    id="panelPolicyInfo"
                    className="panel"
                    role="tabpanel"
                    aria-labelledby="tab-PolicyInfo"
                >
                    <div
                        className="panel-content"
                    >
                        {child}
                    </div>
                </div>
            )
        });
    }

    renderPolicyNumber = () => {
        const { policy } = this.props
        return (
            <span> {"Policy No. " + policy.policyNumber} </span>
        );
    }

    renderPolicyStatus = () => {
        const { policy } = this.props        
        return (
            <span> {policy.currentPolicyStatus} </span>
        );
    }

    render() {
        return (
            <div
                className="container policy-information"
            >
                <div className="row">
                    <div
                        className="col-sm-14"
                    >
                        <div
                            id="commercialTelematicsTabs"
                            className="tabs"
                        >
                            {/* Tab Headers */}
                            {this.renderTabs()}
                            {/* Tab Content Panels */}
                            {this.renderPanels()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
